import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  float: left;
  background: ${({ theme }) =>
    `linear-gradient(to bottom,${theme.colors.GRADIEN_COLOR_1}, ${theme.colors.GRADIENT_COLOR_2})`};
  position: fixed;
  height: 100%;
  left: 0px;
  top: 0px;
  display: flex;
  flex-direction: column;
`;
